<div class="w-full p-4 md:p-12" *transloco="let t">
  <div class="max-w-[400px] ml-auto mb-4">
    @if(myOperators[0]){ <std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [filterable]="false"
      [currentValue]="{id:'-1',name:t('all')}" customClassContaier="border-primary custom-select" [bindValue]="'id'"
      [bindLabel]="'name'" placeholder="Seleziona operatore" (onChangeValue)="getTimeSheetSalon($event)"
    [data]="myOperators"></std-select>}
  </div>
  <div [ngClass]="{'pointer-events-none opacity-35 select-none': !currentOperator?.id}">
    @if (showCalendar) {
      <std-calendar [calendarModes]="calendarModes" [translatePipe]="t" weeklyShowHoursMode="daily" [canResizeEvents]="false" [daysOff]="[]" (close)="currentEventSelected = {}"
        (showEvent)="currentEventSelected = $event;isNewPrenotation = false;currentSalon = currentEventSelected.salon;currentEvent = $event;manageElementsEvent($event)"
        [mobileItems]="mobileItems" [arrayEvents]="arrayPrenotations" (close)="currentEvent = {}"
        (onDayClick)="currentEventSelected = {};dateSelect($event)" [currentMode]="isCalendarWeekly ? 'weekly' : 'monthly'" [currentDate]="currentDate"
        (currentWeek)="getNewEventsWeek($event)" (currentMonthYear)="getNewEventsMonth($event)">
        <div customModal class='size-full p-5 bg-white w-full h-full min-w-[600px] max-w-[650px]'>
          <div class="w-full flex justify-between items-center">
            <div class="w-full h-full flex gap-2 items-center">
              <div class="w-[6px] h-[44px] bg-[#D9D9D9]"></div>
              <div class="flex flex-col items-start justify-center">
                <div class="text-[16px] text-[#102A35] font-medium leading-[19.2px]">
                  {{ getEventTime(currentEventSelected.dateStart) }}/
                  {{ getEventTime(currentEventSelected.dateEnd)}}
                </div>
                <div class="text-[20px] font-medium text-[#102A35] leading-6 ">{{currentEventSelected.name}}</div>
              </div>
            </div>
          </div>
          <div class="w-full h-full flex flex-col items-start justify-start gap-5 mt-5">
            <div class="w-full h-full flex flex-col gap-2 items-start justify-start">
              <div class="text-base font-semibold leading-[19.2px] text-[#102A35]">Salone</div>
              <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                {{currentEventSelected?.salon?.name}}
              </div>
            </div>
            <div class="w-full h-full flex flex-col gap-2 items-start justify-start">
              <div class="text-base font-semibold leading-[19.2px] text-[#102A35]">Note</div>
              <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                {{currentEventSelected.description ? currentEventSelected.description : ""}}
              </div>
            </div>
          </div>
          <div class="mt-[15px] w-full flex place-content-center" *transloco="let t">
            @if (currentEventSelected?.completeEvent) {
              <std-button class="w-[32%]"
                (click)="modalDelete = true;refreshCalendar()" size="sm"
              buttonClass="bg-red-500 text-white hover:bg-red-500 active:bg-red-500 focus:bg-red-500">{{t('modal.delete')}}</std-button>
            }
            <std-button class="w-[32%] mx-[2%]" (click)="isEditEvent = true;showModalBooking = true;refreshCalendar()"
            size="sm">{{t('modal.edit')}}</std-button>
            @if(currentEventSelected?.user?.phone){<std-button class="w-[32%]" (click)="sendReminderWhatapp(t)"
            size="sm">{{t('sendReminderWhatapp')}}</std-button>}
          </div>
        </div>
      </std-calendar>
    }
  </div>
</div>
@if(showModalBooking){<std-modal [closeOnOutside]="false" cardClass="!max-w-[90vw] min-w-[440px]"
  [show]="showModalBooking" headerClass="bg-primary" (close)="showModalBooking = false">
  <div header class="text-white">{{isEditEvent ? 'Modifica turno' : 'Crea turno'}} {{ getFormattedDate(
  currentDate)}}</div>
  <div content class="min-w-[250px] max-w-[400px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar">

    @if(currentEventSelected){ <std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [filterable]="false"
       customClassContaier="border-primary custom-select" [currentValue]="currentEventSelected.salon" [bindValue]="'id'"
      [bindLabel]="'name'" placeholder="Seleziona salone" (onChangeValue)="currentSalon = $event"
    [data]="mySalons"></std-select>}
    @if(!currentEventSelected){ <std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
      customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [filterable]="false"
       customClassContaier="border-primary custom-select"  [bindValue]="'id'"
      [bindLabel]="'name'" placeholder="Seleziona salone" (onChangeValue)="currentSalon = $event"
    [data]="mySalons"></std-select>}



    @if(isEditEvent){

      @if(changeSelectStart){<std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [currentValue]="selectStartDate"
        customClassContaier="border-primary custom-select" [filterable]="true" placeholder="Seleziona un'orario"
        (onChangeValue)="adjustDateSelect($event,'startDate')" label="Inizio"
      customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar" [data]="timetables"></std-select>}
      @if(!changedSelectStart){<std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [currentValue]="selectEndDate"
        customClassContaier="border-primary custom-select" [filterable]="true" label="Fine"
        placeholder="Seleziona un'orario" (onChangeValue)="adjustDateSelect($event,'endDate')"
      customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar" [data]="timetables"></std-select>}
      @if(changedSelectStart && changeSelectEnd){<std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [currentValue]="selectEndDate"
        customClassContaier="border-primary custom-select" [filterable]="true" label="Fine"
        placeholder="Seleziona un'orario" (onChangeValue)="adjustDateSelect($event,'endDate')"
      customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar" [data]="timetables"></std-select>}
    }




    @if(!isEditEvent){




      @if(changeSelectStart){<std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
        [currentValue]="selectStartDate" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
        customClassContaier="border-primary custom-select" [filterable]="true" placeholder="Seleziona un'orario"
        (onChangeValue)="adjustDateSelect($event,'startDate')" label="Inizio"
      customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar" [data]="timetables"></std-select>}


      @if(!changedSelectStart){
        <std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          customClassContaier="border-primary custom-select" [filterable]="true" label="Fine"
          placeholder="Seleziona un'orario" (onChangeValue)="adjustDateSelect($event,'endDate')"
        customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar" [data]="timetables"></std-select>}

        @if(changedSelectStart && changeSelectEnd){
          <std-select typeOfFiltrableSelect="startsWith" customLabel="label-input"
            customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
            customClassContaier="border-primary custom-select" [currentValue]="selectEndDate" [filterable]="true" label="Fine"
            placeholder="Seleziona un'orario" (onChangeValue)="adjustDateSelect($event,'endDate')"
          customClassContainerElement="max-h-[200px] overflow-y-scroll hide-bar" [data]="timetables"></std-select>}
        }





        <std-input customInputClass="custom-input" customLabel="label-input" labelPosition="top" label="Note"
        placeholder="Note" [(ngModel)]="currentEvent.description" type="text"></std-input>

        <div class="flex gap-[4%]">
          <div class="w-[48%]"><std-button (click)="showModalBooking=false"
          buttonClass="bg-primary focus:bg-primary hover:bg-primary">Annulla</std-button></div>
          <div class="w-[48%]" [ngClass]="{'pointer-events-none opacity-35': !currentEvent.startDate || !currentEvent.endDate|| !currentSalon}"><std-button (click)="manageCalendar()"
            [disabled]=" !currentEvent.startDate || !currentEvent.endDate"
          buttonClass="bg-primary focus:bg-primary hover:bg-primary">Salva</std-button></div>
        </div>
      </div>
    </std-modal>}

    <!-- delete modal -->
    @if(modalDelete){<std-modal [closeOnOutside]="false" cardClass="!max-w-[90vw]" [show]="modalDelete"
      headerClass="bg-primary" (close)="modalDelete = false">
      <div header class="text-white">Cancella turno</div>
      <div content class="min-w-[250px] max-w-[400px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar">
        <div class="w-full flex" *transloco="let t">
          <std-button class="w-[48%]  mr-[4%] " (click)="deleteBooking()" size="sm"
          buttonClass="bg-red-500 text-white hover:bg-red-500 active:bg-red-500 focus:bg-red-500">Conferma</std-button>
          <std-button class="w-[48%]" (click)="modalDelete=false" size="sm">Annulla</std-button>
        </div>
      </div>
    </std-modal>}